import { render, staticRenderFns } from "./merchant_menu_auth.vue?vue&type=template&id=8caf05d2&scoped=true"
import script from "./merchant_menu_auth.vue?vue&type=script&lang=ts"
export * from "./merchant_menu_auth.vue?vue&type=script&lang=ts"
import style0 from "./merchant_menu_auth.vue?vue&type=style&index=0&id=8caf05d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8caf05d2",
  null
  
)

export default component.exports